import Vue from 'vue';

// import common from './routes/common';
// import singleSession from './routes/single-session';
// import singleExpert from './routes/single-expert';
// import archive from './routes/post-type-archive-session';
// import checkout from './routes/checkout';

import vSelect from 'vue-select';
import checkoutView from './vue/Checkout/CheckoutView.vue';
import calCheck from './vue/calcheck.vue';
import Boek from "./vue/Boek.vue";
import Agenda from "./vue/Agenda.vue";
import filters from "./vue/filters.vue";

/** Populate Router instance with DOM routes */
// const routes = new Router({
//   common,
//   singleSession,
//   singleExpert,
//   archive,
//   checkout,
// });

new Vue({
  el: '#app .main',
  components: {
    checkoutView,
    calCheck,
    Boek,
    Agenda, // geen .main misschien?,
    filters,
  },
  mounted() {
    console.log("Vue mounted succesfully.")
  },
  methods: {
    moneyFormat: (val, decimals = 2, style = 'currency') => {
      let formatter = new Intl.NumberFormat('nl', {
        style: style, // decimal
        currency: 'EUR',
        // maximumFractionDigits: decimals,
        minimumFractionDigits: decimals,
        useGrouping: true,
      });

      let formatted = formatter.format(val);

      return formatted;
    },
  }
});

Vue.component('v-select', vSelect);
// Vue.component('CheckoutView', CheckoutView)



// WEBPACK FOOTER //
// ./scripts/vue.js